import { React, useState, useContext } from 'react'
import axios from "axios";
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from '../../../../App';
import { API_URL } from '../../../../Constant';
import { generateExcel } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import { getFormattedDate,isEndDateGreater,changeDateFormat} from "../../../../Custom/Custom";
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../../../assets/Messages.json';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import priceTitle from '../../../../price.json';


function ListReportUrbanWages() {

    const token = useContext(MyContextProvider).token;
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const storedLanguage = localStorage.getItem('language');
    const today = new Date();
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };




  //handle excel sheet ***************
  const handleGenerateExcel = async() => {
    if (!startDate || !endDate) {
        toast.error('Please select the date range', messages.COLOR_RED);
        return;
      }
    if(!isEndDateGreater(startDate,endDate)){
        toast.error(messages.DATE_BETWEEN_MESSAGE, messages.COLOR_RED);
        return;
      }

      let sDate= getFormattedDate(startDate);
      let eDate=  getFormattedDate(endDate);

  try {
  showLoading(true);

      let post_data={
          fromDate: sDate,
          toDate:eDate
      }
    
      const response = await axios.post(`${API_URL}api/price/priurbanwagesopreport`, post_data, config);
      const reportData = response.data;
       if(reportData.status){
          let allData= reportData.data.GroupCodes;
          
          // Sort data by DISTRICT_CODE in natural order (01, 02, 03... 10, 11, 12...)
          // if (allData && Array.isArray(allData)) {
          //   allData.sort((a, b) => {
          //     const districtCodeA = a.DISTRICT_CODE ? parseInt(a.DISTRICT_CODE, 10) : 0;
          //     const districtCodeB = b.DISTRICT_CODE ? parseInt(b.DISTRICT_CODE, 10) : 0;
          //     return districtCodeA - districtCodeB;
          //   });
          // }
          
          downloadReport(allData,sDate,eDate)

      }else{
        toast.error('Data is not found', messages.COLOR_RED);
      }
    
 } catch (error) {
  console.error(error);

  }finally{
  showLoading(false);
  }
 }


const formatGrossValue = (value) => {
  if (value === 0) return '0.00';
  if (value === "NaN" ) return '';
  if (value === '' || value === null) return '';
  return Number(value).toFixed(2);
};
 
 
 
 const downloadReport=(allData,sDate,eDate)=>{

 const transformedData = allData.map((item ,index)=>{
   return [
     item.WAGE_MONTH,
     item.DISTRICT_NAME,
     formatGrossValue(item.CARPENTER_SECOND_WAGE),
     formatGrossValue(item.MASON_SECOND_WAGE),
     formatGrossValue(item.UNSKILLED_FIRST_WAGE)
    ]

  })
   let redGroup = [''];

  let excelObjectData = {
       fileName:`PriUrbanOutputReport(${sDate.replace(/ /g, "_")}-${eDate.replace(/ /g, "_")})`,
       fileType:'xls',
       sheetName: 'pri_urban_wages_output_report',
       firstRowMergeCells: 'A1:E1',
       firstRowExportDate:  changeDateFormat(new Date()),
       secondRowMergeCells: 'A2:E2',
       secondRowText: `Urban Wage ${sDate}-${eDate} (Base Year 2011-12=100)`,
       headerEnglishColumns:['MONTH','DISTRICT','CARPENTER','MESON','UNSKILLED'],
      excelRowData:transformedData,
      redGroup:redGroup
     };


      excelObjectData.excelRowData = transformedData;
      generateExcel(excelObjectData);
   }
 


  return (
    <>
           <ToastContainer />
           <GlobalLoading />
           <div className="container-fluid py-3">
               <div className="card mx-3 mb-3">
                   <div className="card-body pb-1">
                       <div className="row">
                           <div className="col-12">
                               <h4 className="page_heading">
                                   <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.LIST_REPORT_URBAN_WAGES : priceTitle.en.LIST_REPORT_URBAN_WAGES }} />
                               </h4>
                           </div>
                       </div>
                       <div className="row align-items-end">
                           <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-3">
                               <label className="form-label">From Date</label>
                               <DatePicker
                                   className="form-control calendar_icon"
                                   wrapperClassName="w-100 d-block"
                                   selected={startDate}
                                   onChange={(e) => { setStartDate(e) }}
                                   dateFormat="MMM yyyy"
                                   showMonthYearPicker
                                   placeholderText="Select month"
                                   maxDate={today}
                               />
                           </div>

                           <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-3">
                               <label className="form-label">To Date</label>
                               <DatePicker
                                   className="form-control calendar_icon"
                                   wrapperClassName="w-100 d-block"
                                   selected={endDate}
                                   onChange={(e) => { setEndDate(e) }}
                                   dateFormat="MMM yyyy"
                                   showMonthYearPicker
                                   placeholderText="Select month"
                                   maxDate={today}
                               />
                           </div>

                           <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-3">
                               <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                           </div>
                       </div>
                   </div>
               </div>
           </div>
      </>
  )
}

export default ListReportUrbanWages